import Footer from "../components/footer";
import Header from "../components/header";
import PageHeader from "../components/pageHeader";
import SideNav from "../components/sidenav";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams, useNavigate, NavLink } from "react-router-dom";


const ViewProfileArtist = () => {

    let userInfo = JSON.parse(localStorage.getItem('admin-info'));
    
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("address"); // State to track active tab

    const [addressDetails, setAddressDetails] = useState({
        address:'', city: '', state: '', country: '', pin: '', gst: '', tradeName: '', 
        aadhar: '', contact: '', username: '', email: '', mobile: '', userType: '',
        userStatus: '', featured_artist: '', image: ''
        // Additional fields as needed
    });
    const [aboutDetails, setAboutDetails] = useState({
        about: '', awards: '', shows: '', exhibition: ''
    })

    

    const handleTabChange = (tabName) => {
        setActiveTab(tabName);
      };

      // Function to Fetch data from API for dropdown
    const fetchData = useCallback(async (url, setData) => {
        debugger;
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Failed to fetch data');
            }
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        if (userInfo.user_id) {
            
            fetchData(`https://igapi.heuristticminds.com/api/UsersList/Get-GetUserAddressByUserID?User_ID=${userInfo.user_id}`, setAddressDetails);
            fetchData(`https://igapi.heuristticminds.com/api/UsersList/Get-GetUserAboutByUserID?User_ID=${userInfo.user_id}`, setAboutDetails);
        }
    }, [userInfo.user_id]);

    return(
        <>
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">

                    <PageHeader name='My Profile' icon='bi bi-activity' />
                    <div className="container-xl px-4">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <div className="card mb-4 vh-100">
                                    <div className="card-header">My Profile</div>
                                    <div className="card-body">
                                        
                                        <div className="clearfix"></div>
                                        
                                        {/* Tab Navigation */}
                                        <ul className="nav nav-tabs">
                                                <li className="nav-item">
                                                    <button
                                                    className={`nav-link ${activeTab === "address" ? "active" : ""}`}
                                                    onClick={() => handleTabChange("address")}
                                                    >
                                                        Address
                                                    </button>
                                                </li>
                                                <li className="nav-item">
                                                    <button
                                                    className={`nav-link ${activeTab === "about" ? "active" : ""}`}
                                                    onClick={() => handleTabChange("about")}
                                                    >
                                                        About
                                                    </button>
                                                </li>
                                            </ul>

                                        {/* Tab Content */}
                                    <div className="tab-content">
                                        <div className={`tab-pane ${activeTab === "address" ? "active" : ""}`}>
                                            {/* Address Form */}
                                        <form>
                                        <NavLink className="btn btn-primary float-end" to={'/editProfileArtist/1'}><i className="bi bi-pencil"></i> Edit</NavLink>
                                        <div className={`p-4 pt-2`}>                                                
                                            <div className="row">
                                            <div className="col-sm-6 form-group mb-3">
                                                {addressDetails.image && (
                                                    <img className="m-2" src={`../images/profile/${addressDetails.image}`} alt="" width="100px" />
                                                    )}
                                                </div>
                                                <div className="col-sm-6 form-group mb-3">
                                                <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Address : </label>
                                                <label> {addressDetails.address}</label>                                                        

                                                    </div>
                                            </div>
                                                <div className="row">
                                                <div className="col-sm-6 form-group mb-3">
                                                <h4><label> {addressDetails.username}</label>  </h4><label>  {addressDetails.featured_artist === 'No' ? '(Featured Artist)' : ''}</label>
                                                </div>
                                                <div className="col-sm-3 form-group mb-3">
                                                <label style={{ marginRight: '10px', fontWeight: 'bold' }}>City : </label>
                                                        <label>{addressDetails.city}</label>  
                                                                                                                

                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                    <label style={{ marginRight: '10px', fontWeight: 'bold' }}>State : </label>
                                                        <label>{addressDetails.state}</label>                                    

                                                    </div>
                                                </div>
                                                <div className="row">
                                                <div className="col-sm-6 form-group mb-3">
                                                <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Email ID : </label>
                                                        <label>{addressDetails.email}</label>  
                                                </div>
                                                <div className="col-sm-3 form-group mb-3">
                                                <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Country : </label>
                                                        <label>{addressDetails.country}</label>                                         

                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                    <label style={{ marginRight: '10px', fontWeight: 'bold' }}>PIN/ZIP Code : </label>                                                                                                              
                                                        <label>{addressDetails.pin}</label>  
                                                    </div>
                                                </div>
                                                <div className="row">
                                                <div className="col-sm-6 form-group mb-3">
                                                <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Mobile : </label>
                                                        <label>{addressDetails.mobile}</label>  
                                                </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                    <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Aadhar : </label>
                                                        <label>{addressDetails.aadhar}</label>                                                   

                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                    <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Alternate Contact No : </label>
                                                        <label>{addressDetails.contact}</label>                                                       

                                                    </div>
                                                </div>
                                                <div className="row">
                                                <div className="col-sm-6 form-group mb-3">
                                                <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Status : </label>
                                                        <label>{addressDetails.userStatus}</label>  
                                                </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                    <label style={{ marginRight: '10px', fontWeight: 'bold' }}>GSTIN : </label>
                                                        <label>{addressDetails.gst}</label>                                                  

                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                    <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Trade Name : </label>
                                                        <label>{addressDetails.tradeName}</label>                                                         

                                                    </div>
                                                    
                                                </div> 
                                            </div>
                                        </form>
                                        </div>
                                        <div className={`tab-pane ${activeTab === "about" ? "active" : ""}`}>
                                        <form>
                                        <NavLink className="btn btn-primary float-end" to={'/editProfileArtist/2'}><i className="bi bi-pencil"></i> Edit</NavLink>
                                            <div className={`p-4 pt-2`}>  
                                            <div className="row">
                                                    <div className="col-sm-12 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Amout Me : </label>
                                                        <div dangerouslySetInnerHTML={{ __html: aboutDetails.about }} />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12 form-group mb-3">
                                                    <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Award Details : </label>
                                                        <div dangerouslySetInnerHTML={{ __html: aboutDetails.about }} />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12 form-group mb-3">
                                                    <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Show Details : </label>
                                                        <div dangerouslySetInnerHTML={{ __html: aboutDetails.shows }} />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12 form-group mb-3">
                                                    <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Exhibition Details : </label>
                                                        <div dangerouslySetInnerHTML={{ __html: aboutDetails.exhibition }} />
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
            </div>
        </>
    )
};
export default ViewProfileArtist;